export function isAccessTokenExpired(tokenData) {
    const currentUnixTimestamp = new Date().getTime() / 1000;
    return currentUnixTimestamp > tokenData.token_acquired_unix_timestamp + tokenData.expires_in;
}
export function readAndDecodeKeyValuePairsFromFragment(fragment) {
    const noHashFragment = fragment[0] === '#' ? fragment.substr(1) : fragment;
    const result = {};
    const pairs = noHashFragment.split('&');
    for (const pair of pairs) {
        const [key, value] = pair.split('=');
        const decodedKey = decodeURIComponent(key);
        const decodedValue = decodeURIComponent(value);
        result[decodedKey] = decodedValue;
    }
    return result;
}
//# sourceMappingURL=Oauth2Service.js.map